import { Notificacion } from '../models/notificacion.model';
import { NotificacionesRestService } from './notificaciones-rest.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { Injectable } from '@angular/core';

/**
 * Data service que almacena número de notificaciones pendientes de leer,
 * lo que permite actualizar este número en la cabecera.
 */
@Injectable({ providedIn: 'root' })
export class NotificacionesDataService {
  private _numNotificacionesPorLeer = new BehaviorSubject<number>(0);

  constructor(private notificacionesRestService: NotificacionesRestService) {}

  set numeroNotificacionesPorLeer(numeroPorLeer: number) {
    this._numNotificacionesPorLeer.next(numeroPorLeer);
  }

  get numeroNotificacionesPorLeer(): number {
    return this._numNotificacionesPorLeer.getValue();
  }

  get numeroNotificacionesPorLeerObservable(): Observable<number> {
    return this._numNotificacionesPorLeer.asObservable();
  }

  actualizarNotificacionesPorLeer(): void {
    this.notificacionesRestService.contarNotificacionesNoLeidas()
      .pipe(take(1)).subscribe((notificaciones: number) => {
        this._numNotificacionesPorLeer.next(notificaciones);
      });
  }

}
